// src/components/Helpfaq.jsx
import { useTheme, useMediaQuery } from "@mui/material";
import HelpfaqMobile from "./HelpfaqMobile";
import HelpfaqDesktop from "./HelpfaqDesktop";
import { Box } from "@mui/material";

export default function Helpfaq() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // return isMobile ? <HelpfaqMobile /> : <HelpfaqDesktop />;
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "100vh",
      }}
    >
      {isMobile ? <HelpfaqMobile /> : <HelpfaqDesktop />}
    </Box>
  );
}
